import { render, staticRenderFns } from "./RowBlockBuyingManualInsurance.vue?vue&type=template&id=bee2a582&"
import script from "./RowBlockBuyingManualInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingManualInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports